import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "dtwin-rule-commands"
  }, [_c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.executionResult'),
      "open": _vm.executionResultPrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        color: 'red',
        emit: 'close'
      }]
    },
    on: {
      "close": function ($event) {
        _vm.executionResultPrompt = false;
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.lastExecutionResult) + "\n  ")]), _c('p', {
    staticClass: "pb-2 card-description"
  }, [_vm.rule && _vm.rule.id ? [(_vm.rule.properties.stateMetrics || []).length > 0 ? [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.commandsMetricTemplateText')) + "\n      ")] : [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.commandsMetricTemplateTextNoMetrics')) + "\n      ")]] : [(_vm.rule.properties.stateMetrics || []).length > 0 ? [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.commandsMetricTemplateTextCreate'))
    }
  })] : [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.commandsMetricTemplateTextCreateNoMetrics'))
    }
  })]], _vm._v("\n     \n    "), (_vm.rule.properties.geoFences || []).length > 0 ? [_c('custom-code', [_vm._v(_vm._s(_vm.formattedVariable({
    key: 'geofence_twintitle'
  })))]), _vm._v("\n      ,\n      "), _c('custom-code', [_vm._v(_vm._s(_vm.formattedVariable({
    key: 'geofence_twinid'
  })))]), _vm._v("\n      ,\n      "), _c('custom-code', [_vm._v(_vm._s(_vm.formattedVariable({
    key: 'geofence_trigger'
  })))]), _vm._v("\n      ,\n    ")] : _vm._e(), (_vm.rule.properties.stateMetrics || []).length > 0 ? [_vm._l(_vm.rule.properties.stateMetrics, function (metric, i) {
    return [_c('custom-code', [_vm._v(_vm._s(_vm.formattedVariable(metric)))]), i < _vm.rule.properties.stateMetrics.length - 1 ? [_vm._v(",")] : _vm._e()];
  }), _vm._v("\n       \n      "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.commandsTwinNameText'))
    }
  }), _vm._v("\n       \n    ")] : _vm._e(), _c('custom-code', [_vm._v(_vm._s(_vm.formattedVariable({
    key: 'twintitle'
  })))]), _vm._v("\n    ,\n    "), _c('custom-code', [_vm._v(_vm._s(_vm.formattedVariable({
    key: 'twinid'
  })))]), _vm._v("\n    ,\n    "), _c('custom-code', [_vm._v(_vm._s(_vm.formattedVariable({
    key: 'twinlink'
  })))]), _vm.twinType !== 'virtualDevice' ? [_vm._v("\n      ,\n      "), _c('custom-code', [_vm._v(_vm._s(_vm.formattedVariable({
    key: 'twinparenthierarchy'
  })))])] : [_vm._v("\n      ,\n      "), _c('custom-code', [_vm._v(_vm._s(_vm.formattedVariable({
    key: 'vdevice_group'
  })))]), _vm._v("\n      ,\n      "), _c('custom-code', [_vm._v(_vm._s(_vm.formattedVariable({
    key: 'lastseen'
  })))])], !_vm.isTemplateContext && Object.keys(_vm.dtwin.data.keyValue || {}).length > 0 ? [_vm._v("\n      ,\n      "), _vm._l(Object.keys(_vm.dtwin.data.keyValue), function (key, i) {
    return [_c('custom-code', [_vm._v(_vm._s(_vm.formattedVariable({
      key
    })))]), i < Object.keys(_vm.dtwin.data.keyValue).length - 1 ? [_vm._v(",")] : _vm._e()];
  })] : _vm._e(), (_vm.rule.properties.actionTemplateStateIds || []).length > 0 ? [_vm._l(_vm.states, function (state) {
    return [_vm.rule.properties.actionTemplateStateIds.indexOf(state.id) >= 0 ? [_vm._v("\n          ,\n          "), _c('custom-code', [_vm._v(_vm._s(_vm.formattedTemplateState(state)))])] : _vm._e()];
  })] : _vm._e()], 2), _c(VExpansionPanels, {
    staticClass: "pb-2"
  }, [_vm.isTemplateContext && !_vm.dtwin ? _c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('p', {
    staticClass: "card-description"
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.templateSampleData')) + "\n        ")])]), _c(VExpansionPanelContent, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.dependingOnTheType')) + "\n        "), _c('pre', {
    staticClass: "card-description"
  }, [_vm._v("        number: 42\n        json: '{\\\\\"key\\\\\":\\\\\"value\\\\\"}'\n        boolean: true\n        string: 'testString'\n        ")]), _vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.metaInformation')) + "\n        "), _c('pre', {
    staticClass: "card-description"
  }, [_vm._v("        twintitle: 'Digital Twin 1'\n        twinid: 1\n        twinlink: 'https://niotix.io'\n        twinparenthierarchy: 'hierarchy'\n        geofence_twintitle: 'GEOFENCE-ZONE-TWIN'\n        geofence_twinid: 'GEOFENCE-ZONE-TWIN-ID'\n        geofence_trigger: 'GEOFENCE-TRIGGER'\n        vdevice_group: 'group1, group2'\n        lastseen: '2024-07-08 06:48:33.07+00'\n      ")])])], 1) : _vm._e()], 1), _c('p', {
    staticClass: "pb-6 card-description"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.commandsTemplateStateText'))
    }
  }), _c(VCombobox, {
    staticClass: "mt-2",
    attrs: {
      "disabled": _vm.disabled,
      "label": _vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.stateIdentifiers.label'),
      "items": _vm.states.map(s => _vm.isTemplateContext ? s.key : s.id),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "multiple": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.refreshTemplateStates
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        item
      }) {
        return [_c(VListItemContent, {
          domProps: {
            "textContent": _vm._s(_vm.getStateKey(item))
          }
        })];
      }
    }, {
      key: "selection",
      fn: function ({
        attrs,
        item
      }) {
        return [_c(VChip, _vm._b({
          attrs: {
            "small": "",
            "close": ""
          },
          on: {
            "click:close": function ($event) {
              return _vm.removeTemplateState(item);
            }
          }
        }, 'v-chip', attrs, false), [_vm._v("\n          " + _vm._s(_vm.getStateKey(item)) + "\n        ")])];
      }
    }]),
    model: {
      value: _vm.rule.properties.actionTemplateStateIds,
      callback: function ($$v) {
        _vm.$set(_vm.rule.properties, "actionTemplateStateIds", $$v);
      },
      expression: "rule.properties.actionTemplateStateIds"
    }
  })], 1), !_vm.disabled && _vm.hasTwinEditPermission && (_vm.rule.properties.actions || []).length === 0 ? _c(VBtn, {
    class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
    attrs: {
      "color": _vm.color,
      "title": _vm.$i18n_t('Common.addNew'),
      "rounded": "",
      "text": "",
      "data-cy": "add_new_command"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('add-action', 0);
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-plus")]), _vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.addNew')) + "\n  ")], 1) : _vm._e(), _vm._l(_vm.rule.properties.actions, function (action, i) {
    return _c('core-n20Card', {
      key: `action_${i}`,
      class: `dt-card-text-01 ${i === 0 ? 'mt-12' : ''}`,
      scopedSlots: _vm._u([{
        key: "buttons",
        fn: function () {
          return [!_vm.isMobile ? _c('span', [_c(VBtn, {
            class: 'v-btn-x px-3 mx-1 v-btn--rounded bg-rounded-button-' + _vm.color,
            attrs: {
              "disabled": _vm.disabled || !_vm.hasTwinEditPermission || !action.command || !_vm.formValid || _vm.executionInProgress,
              "color": _vm.color,
              "rounded": "",
              "text": ""
            },
            on: {
              "click": function ($event) {
                return _vm.testExecuteAction(i, action);
              }
            }
          }, [_c(VIcon, {
            attrs: {
              "dark": ""
            }
          }, [_vm._v("fal fa-rocket")]), _vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.execute')) + "\n        ")], 1)], 1) : _c('span', [_c(VBtn, {
            class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
            attrs: {
              "disabled": _vm.disabled || !_vm.hasTwinEditPermission || !action.command || !_vm.formValid || _vm.executionInProgress,
              "color": _vm.color,
              "icon": "",
              "info": "",
              "fab": "",
              "text": ""
            },
            on: {
              "click": function ($event) {
                return _vm.testExecuteAction(i, action);
              }
            }
          }, [_c(VIcon, {
            attrs: {
              "dark": ""
            }
          }, [_vm._v("fal fa-rocket")])], 1)], 1), !_vm.disabled ? _c(VBtn, {
            class: 'v-btn-x mx-1 v-btn--rounded bg-rounded-button-' + _vm.color,
            attrs: {
              "color": _vm.color,
              "title": _vm.$i18n_t('Common.delete'),
              "icon": "",
              "info": "",
              "fab": "",
              "text": ""
            },
            on: {
              "click": function ($event) {
                return _vm.$emit('delete-action', i);
              }
            }
          }, [_c(VIcon, {
            attrs: {
              "dark": ""
            }
          }, [_vm._v("fal fa-trash-alt")])], 1) : _vm._e(), !_vm.disabled ? _c(VBtn, {
            class: 'v-btn-x mx-1 v-btn--rounded bg-rounded-button-' + _vm.color,
            attrs: {
              "color": _vm.color,
              "title": _vm.$i18n_t('Common.addNew'),
              "icon": "",
              "info": "",
              "fab": "",
              "text": ""
            },
            on: {
              "click": function ($event) {
                return _vm.$emit('add-action', i);
              }
            }
          }, [_c(VIcon, {
            attrs: {
              "dark": ""
            }
          }, [_vm._v("fal fa-plus")])], 1) : _vm._e()];
        },
        proxy: true
      }], null, true)
    }, [_c('div', {
      staticClass: "commands"
    }, [_c('div', {
      staticClass: "mx-2 my-3",
      staticStyle: {
        "display": "flex",
        "flex-direction": "row",
        "justify-content": "space-between",
        "align-items": "center",
        "min-width": "650px"
      }
    }, [_c('div', {
      staticClass: "mx-1",
      staticStyle: {
        "display": "flex",
        "min-width": "90px"
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.ifCondition')) + "\n        ")]), _c('div', {
      staticClass: "mx-1",
      staticStyle: {
        "display": "flex"
      }
    }, [_vm.rule.properties.conditionEnabled !== false && !_vm.rule.properties.timeTriggerOnly ? _c(VSelect, {
      staticClass: "action-condition-change required",
      attrs: {
        "disabled": _vm.disabled,
        "items": [{
          value: 'CHANGES',
          text: _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.changes')
        }, {
          value: 'EVALUATES',
          text: _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.evaluates')
        }],
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": _vm.requiredRule,
        "hide-details": "",
        "data-cy": "condition_action"
      },
      model: {
        value: action.triggerType,
        callback: function ($$v) {
          _vm.$set(action, "triggerType", $$v);
        },
        expression: "action.triggerType"
      }
    }) : [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.evaluates')) + "\n          ")]], 2), _c('div', {
      staticClass: "mx-1",
      staticStyle: {
        "display": "flex"
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.conditionTo')) + "\n        ")]), _c('div', {
      staticClass: "mx-1",
      staticStyle: {
        "display": "flex"
      }
    }, [_vm.rule.properties.conditionEnabled !== false && !_vm.rule.properties.timeTriggerOnly ? _c(VSelect, {
      staticClass: "action-condition-output required",
      attrs: {
        "disabled": _vm.disabled,
        "items": ['true', 'false'],
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": _vm.requiredRule,
        "hide-details": "",
        "data-cy": "condition_value"
      },
      model: {
        value: action.triggerValue,
        callback: function ($$v) {
          _vm.$set(action, "triggerValue", $$v);
        },
        expression: "action.triggerValue"
      }
    }) : [_c('code', [_vm._v("true")])]], 2), _c('div', {
      staticClass: "mx-1",
      staticStyle: {
        "display": "flex"
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.doExecute')) + "\n        ")]), _vm.hasTwinEditPermission ? _c('div', {
      staticClass: "mx-1",
      staticStyle: {
        "display": "flex"
      }
    }, [_c(VSelect, {
      staticClass: "action-command required",
      attrs: {
        "disabled": _vm.disabled,
        "items": _vm.commands,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": _vm.requiredRule,
        "item-text": "name",
        "item-value": "id",
        "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.command'),
        "hide-details": "",
        "data-cy": "condition_command"
      },
      on: {
        "change": function ($event) {
          return _vm.commandChange(i);
        }
      },
      model: {
        value: action.command,
        callback: function ($$v) {
          _vm.$set(action, "command", $$v);
        },
        expression: "action.command"
      }
    })], 1) : _c('div', {
      staticClass: "mx-1",
      staticStyle: {
        "display": "flex"
      }
    }, [_c('em', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.commands')))])])]), _vm.hasTwinEditPermission && action.command ? _c(VRow, {
      staticStyle: {
        "min-width": "0"
      },
      attrs: {
        "align": "top"
      }
    }, _vm._l(_vm.orderedParamKeysForCommandId(action.command), function (param, j) {
      var _vm$findByCommandId;
      return _c(VCol, {
        key: `actionparam_${i}_${j}`,
        attrs: {
          "cols": "12",
          "sm": "6",
          "md": "4",
          "lg": _vm.getColumnWidth(param, _vm.parametersForCommandId(action.command)[param])
        }
      }, [_c('core-tenant-bridge-config-field', {
        attrs: {
          "disabled": param === 'from' && ((_vm$findByCommandId = _vm.findByCommandId(action.command)) === null || _vm$findByCommandId === void 0 || (_vm$findByCommandId = _vm$findByCommandId.config) === null || _vm$findByCommandId === void 0 ? void 0 : _vm$findByCommandId.service) === 'Outlook365(OAuth2.0)',
          "fieldConfig": _vm.parametersForCommandId(action.command)[param],
          "bridgeType": _vm.findByCommandId(action.command).bridgeType,
          "configKey": param,
          "bridgeManifest": _vm.findByCommandId(action.command).manifest,
          "bridgeConfig": _vm.findByCommandId(action.command).config,
          "bridgeConfigId": _vm.findByCommandId(action.command).configId,
          "bridgeHasValidParameters": true,
          "bridgeHasValidParametersStrict": false,
          "defaultIcon": null
        },
        model: {
          value: action.params[param],
          callback: function ($$v) {
            _vm.$set(action.params, param, $$v);
          },
          expression: "action.params[param]"
        }
      })], 1);
    }), 1) : _vm._e()], 1)]);
  })], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };